import { render, staticRenderFns } from "./TipsGameMobile.vue?vue&type=template&id=7cf9a6c9&scoped=true&"
import script from "./TipsGameMobile.vue?vue&type=script&lang=js&"
export * from "./TipsGameMobile.vue?vue&type=script&lang=js&"
import style0 from "./TipsGameMobile.vue?vue&type=style&index=0&id=7cf9a6c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf9a6c9",
  null
  
)

export default component.exports